import { generateUniqueId } from '../../helpers/common';

export const SEARCH_USERS_REQUEST = generateUniqueId();
export const SEARCH_USERS_SUCCESS = generateUniqueId();
export const SEARCH_USERS_FAILURE = generateUniqueId();

export const SEARCH_SUB_CLIENT_USERS_REQUEST = generateUniqueId();
export const SEARCH_SUB_CLIENT_USERS_SUCCESS = generateUniqueId();
export const SEARCH_SUB_CLIENT_USERS_FAILURE = generateUniqueId();

export const CURRENT_USER_REQUEST = generateUniqueId();
export const CURRENT_USER_SUCCESS = generateUniqueId();
export const CURRENT_USER_FAILURE = generateUniqueId();

export const SELECT_USER = generateUniqueId();

export const CREATE_USER_REQUEST = generateUniqueId();
export const CREATE_USER_SUCCESS = generateUniqueId();
export const CREATE_USER_FAILURE = generateUniqueId();

export const ADD_NEW_USER = generateUniqueId();

export const UPDATE_USER_REQUEST = generateUniqueId();
export const UPDATE_USER_SUCCESS = generateUniqueId();
export const UPDATE_USER_FAILURE = generateUniqueId();

export const DEACTIVATE_USER_REQUEST = generateUniqueId();
export const DEACTIVATE_USER_SUCCESS = generateUniqueId();
export const DEACTIVATE_USER_FAILURE = generateUniqueId();

export const ACTIVATE_USER_REQUEST = generateUniqueId();
export const ACTIVATE_USER_SUCCESS = generateUniqueId();
export const ACTIVATE_USER_FAILURE = generateUniqueId();

export const CHANGE_PAGINATION_PAGE = generateUniqueId();
export const CHANGE_PAGINATION_ROWS_PER_PAGE = generateUniqueId();

export const CHANGE_SEARCH_KEYWORD = generateUniqueId();
export const SET_USER_NAME = generateUniqueId();
export const SET_STATUS = generateUniqueId();

export const SET_NAME = generateUniqueId();
export const SET_COMPANY = generateUniqueId();
export const SET_MAX_SESSION_COMPANY = generateUniqueId();
export const SET_MAX_SESSION_CLIENT = generateUniqueId();
export const SET_EMAIL = generateUniqueId();

export const SET_MOBILE = generateUniqueId();
export const SET_PASSWORD = generateUniqueId();
export const SET_PHONE = generateUniqueId();
export const SET_ROLE = generateUniqueId();
export const SET_SUB_CLIENT = generateUniqueId();
export const SET_PERSONA_ID = generateUniqueId();
export const TOGGLE_DELETE_CONFIRM = generateUniqueId();
export const TOGGLE_STATIONS_DIALOG = generateUniqueId();
export const OPEN_SNACK_BAR = generateUniqueId();
export const CLOSE_SNACK_BAR = generateUniqueId();

export const RESET_ACTION_STATUS = generateUniqueId();